/**
 * Validation problems, as an operator reads them.
 *
 * Shared, because the split between errors and warnings is a decision rather
 * than a formatting choice — errors block a save, warnings never do (H7's
 * show-do-not-police, applied to configuration) — and two screens rendering
 * that distinction differently would teach two different meanings.
 */

import type { Problem } from '@cairn/domain';

export function ProblemList({
  problems,
  heading,
  role,
}: {
  readonly problems: readonly Problem[];
  readonly heading: string;
  readonly role?: 'alert';
}): React.JSX.Element | null {
  if (problems.length === 0) return null;

  return (
    <div {...(role === undefined ? {} : { role })}>
      <h3>{heading}</h3>
      <ul>
        {problems.map((p) => (
          <li key={`${p.field}:${p.message}`}>{p.message}</li>
        ))}
      </ul>
    </div>
  );
}
